import React from "react";
import LibraryComponent from "../LibraryComponent/LibraryComponent";

export default function ExecutionStep({execution_step, isMerging = false, update = (val) => {}, fromStyles = false, liveEdit = false}) {

    return <LibraryComponent
        uniqueId={execution_step.pattern_suggested_exercises_id} // this is kinda weird cause it is not unique but I need it for update field
        name={'Step ' + execution_step.exercise_step_id + ': ' + execution_step.exercise_step}
        startDesc={execution_step.exercise_execution_step_text}
        infoContent={{title: 'Step ' + execution_step.exercise_step_id, text: "Submitted By " + execution_step.display_name + " on " + execution_step.completed_time}}
        update={update}
        isMerging={isMerging}
        fromStyles={fromStyles}
        liveEdit={liveEdit}
    />
}